import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IMarketAssumedValuesApiClient {
    getMarkets(): ng.IPromise<Models.CostCalculation.Market.Market[]>;
    getMarketCapsByMarket(marketCode: string): ng.IPromise<Models.CostCalculation.MarketCap.MarketCap>;
    getMarketsInTerritory(territoryId: number): ng.IPromise<Models.CostCalculation.Market.Market[]>;
    getActiveMarketsForCustomer(identifier: string): ng.IPromise<Models.CostCalculation.Market.Market[]>;
    getMarketTypes(): ng.IPromise<Models.CostCalculation.MarketType.IMarketType[]>;
    getIncentiveTypes(): ng.IPromise<Models.CostCalculation.IncentiveType.IIncentiveType[]>;
    getCurrentIncentiveType(stateCode: string): ng.IPromise<Models.CostCalculation.IncentiveType.IIncentiveType>;
    getAssumedValuesForMarket(marketCode: string): ng.IPromise<any>;
    updateEpcAssumedValuesForMarket(epcAssumedValuesModel: Models.CostCalculation.MarketAssumedValuesModel.IMarketAssumedValuesModel): ng.IPromise<Models.BaseApiResponse.BaseApiResponse>;
    cloneEpcAssumedValues(epcAssumedValuesModel: Models.CostCalculation.CloneEpcAssumedValuesRequest.ICloneEpcAssumedValuesRequest): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.IMarketAssumedValuesModel>;
}

export class MarketAssumedValuesApiClient implements IMarketAssumedValuesApiClient {
    public prefix: string;

    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        this.prefix = "MarketAssumedValues";
    }

    public getMarkets = (): ng.IPromise<Models.CostCalculation.Market.Market[]> => {
        var url = `${this.prefix}/GetMarkets`;
        return this.igsApiClientService.get(url);
    }

    public getMarketCapsByMarket = (marketCode: string): ng.IPromise<Models.CostCalculation.MarketCap.MarketCap> => {
        var url = `${this.prefix}/GetMarketCapsByMarket/${marketCode}`;
        return this.igsApiClientService.get(url);
    }

    public getMarketsInTerritory = (territoryId: number): ng.IPromise<Models.CostCalculation.Market.Market[]> => {
        var url = `${this.prefix}/GetMarketsInTerritory/${territoryId}`;
        return this.igsApiClientService.get(url);
    }

    // active means the current date is between the effective start date and effective end date
    public getActiveMarketsForCustomer = (identifier: string): ng.IPromise<Models.CostCalculation.Market.Market[]> => {
        var url = `${this.prefix}/GetActiveMarketsForCustomer?identifier=${identifier || ''}`;
        return this.igsApiClientService.post(url);
    }

    public getMarketTypes = (): ng.IPromise<Models.CostCalculation.MarketType.IMarketType[]> => {
        var url = `${this.prefix}/GetMarketTypes`;
        return this.igsApiClientService.get(url);
    }

    public getIncentiveTypes = (): ng.IPromise<Models.CostCalculation.IncentiveType.IIncentiveType[]> => {
        var url = `${this.prefix}/GetIncentiveTypes`;
        return this.igsApiClientService.get(url);
    }

    public getCurrentIncentiveType = (stateCode: string): ng.IPromise<Models.CostCalculation.IncentiveType.IIncentiveType> => {
        var url = `${this.prefix}/GetCurrentIncentiveType/${stateCode}`;
        return this.igsApiClientService.get(url);
    }

    public getAssumedValuesForMarket = (marketCode: string): ng.IPromise<any> => {
        var url = `${this.prefix}/GetAssumedValuesForMarket/${marketCode}`;
        return this.igsApiClientService.get(url);
    }

    public updateEpcAssumedValuesForMarket = (epcAssumedValuesModel: Models.CostCalculation.MarketAssumedValuesModel.IMarketAssumedValuesModel): ng.IPromise<Models.BaseApiResponse.BaseApiResponse> => {
        var url = `${this.prefix}/UpdateAssumedValuesForMarket`;
        return this.igsApiClientService.post(url, epcAssumedValuesModel);
    }

    public cloneEpcAssumedValues = (epcAssumedValuesModel: Models.CostCalculation.CloneEpcAssumedValuesRequest.ICloneEpcAssumedValuesRequest): ng.IPromise<Models.CostCalculation.MarketAssumedValuesModel.IMarketAssumedValuesModel> => {
        var url = `${this.prefix}/CloneEpcAssumedValues`;
        return this.igsApiClientService.post(url, epcAssumedValuesModel);
    }
}
